import {
  IServicePartner,
  IServiceTicket,
} from "../models/serviceManagement.model";
import axiosSetup from "../utils/axiosSetup";

export const addServicePartnerApi = async (servicePartner: IServicePartner) => {
  try {
    const response = await axiosSetup.post(
      "serviceManagement/add-service-partner",
      servicePartner,
    );
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

export const fetchServicePartners = async (filters?: {
  searchQuery?: string;
  district?: string;
  taluka?: string;
  pincode?: string;
}) => {
  try {
    const response = await axiosSetup.get(
      "serviceManagement/get-service-partners",
      {
        params: filters ?? {},
      },
    );

    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

export const addServiceTicketApi = async (serviceTicket: IServiceTicket) => {
  try {
    const response = await axiosSetup.post(
      "serviceManagement/add-service-ticket",
      serviceTicket,
    );
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

export const fetchServicePartnersByFilter = async (filters: {
  pincode?: string;
  district?: string;
  taluka?: string;
}) => {
  try {
    const response = await axiosSetup.get(
      "serviceManagement/get-service-partners-by-filter",
      {
        params: filters,
      },
    );
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message || "Failed to search service partners";
  }
};

export const fetchServiceStatuses = async () => {
  try {
    const response = await axiosSetup.get(
      "serviceManagement/get-service-statuses",
    );
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

export const fetchServiceTicketsByStatus = async (
  status: string,
  page: number = 1,
  limit: number = 50,
) => {
  const params = new URLSearchParams();
  params.append("status", status);
  params.append("page", String(page));
  params.append("limit", String(limit));

  const res = await axiosSetup.get(
    `/serviceManagement/get-service-tickets-by-status?${params.toString()}`,
  );
  const payload = res.data.data || {};
  return {
    tickets: payload.tickets || [],
    totalCount: payload.count || 0,
    page: payload.page || page,
    limit: payload.limit || limit,
    hasMore: (payload.tickets?.length || 0) === Number(payload.limit || limit),
  };
};

export const updateServiceTicketStatusApi = async (
  currentStatus: string,
  destinationStatus: string,
  ticketId: string,
  destinationIndex: number,
  currentIndex: number,
) => {
  try {
    const response = await axiosSetup.put(
      "/serviceManagement/update-service-ticket-status",
      {
        currentStatus,
        destinationStatus,
        ticketId,
        destinationIndex,
        currentIndex,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error updating service ticket board:", error);
    throw error;
  }
};

export const updateServiceTicketApi = async (
  ticketId: string,
  payload: Partial<IServiceTicket>,
) => {
  try {
    const response = await axiosSetup.put(
      `/serviceManagement/update-service-ticket/${ticketId}`,
      payload,
    );
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

export const fetchInverterModelNo = async () => {
  try {
    const response = await axiosSetup.get(
      "serviceManagement/get-inverter-model-no",
    );
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

export const fetchServiceErrorCodes = async () => {
  try {
    const response = await axiosSetup.get(
      "serviceManagement/get-service-error-codes",
    );
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

export const addTalukaApi = async (district: string, taluka: string) => {
  try {
    const response = await axiosSetup.post("/states/add-taluka", {
      district,
      taluka,
    });
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message || "Failed to add taluka";
  }
};

export const updateServicePartnerApi = async (
  id: string,
  payload: Partial<IServicePartner>,
) => {
  try {
    const response = await axiosSetup.put(
      `/serviceManagement/update-service-partner?id=${id}`,
      payload,
    );
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message || "Failed to update service partner";
  }
};
